import { baseApi } from '../baseApi';
import { CertificationModel } from '../../models/certificationModel';
import { cleanObject } from '../../utils/objectUtils';

export async function createCertificationReq(
  newCertification: CertificationModel,
  personId: string,
) {
  let url = '/officiating/person/certification?';
  let queryParamsObj = cleanObject({
    personId,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.post(url + queryParams, { newCertification });
}

export async function getCertificationsReq(certFamily: string, certType?: string) {
  let url = '/officiating/person/certification?';
  let queryParamsObj = cleanObject({
    certFamily,
    certType,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<CertificationModel[]>(url + queryParams);
}

export async function getCertificationsByIdReq(
  certFamily: string,
  personId: string,
  certType?: string,
) {
  let url = '/officiating/person/certification/other?';
  let queryParamsObj = cleanObject({
    certFamily,
    certType,
    personId,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<CertificationModel[]>(url + queryParams);
}

export async function deleteCertificationReq(certificateId: string) {
  let url = '/officiating/person/certification?';
  let queryParamsObj = cleanObject({
    certificateId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.delete(url + queryParams);
}

export async function updateCertificationReq(certification: CertificationModel) {
  let url = '/officiating/person/certification';

  return baseApi.put(url, { certification });
}
